import { MessageCircle } from 'lucide-react';

export default function WhatsAppButton() {
  const phoneNumber = "447881420773";
  const message = "Hi! I'm interested in Woodhouse & Archer talent agency services.";
  
  const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;

  return (
    <a
      href={whatsappUrl}
      target="_blank"
      rel="noopener noreferrer"
      className="whatsapp-button"
      data-testid="whatsapp-button"
      aria-label="Chat on WhatsApp"
    >
      <MessageCircle size={28} />
    </a>
  );
}
